import React from 'react';
import { useAuth } from 'react-oidc-context';
import { useParams } from 'react-router-dom';

import {
  FacilitatorChat,
  FasilitatorChatProps
} from '../../../components/facilitator/chat';
import {
  FacilitatorChatContext,
  FacilitatorChatContextProps
} from '../../../contexts/facilitator-chat';
import { GetGameChatHistory } from '../../../services/games';
import { ChatState } from '../../../types/state/websocket/chat-state';

export const AllPlayersChat = ({
  onSendMessage = () => {},
  ...props
}: FasilitatorChatProps) => {
  const { gameCode } = useParams();
  const auth = useAuth();

  const { chatHub } = React.useContext(
    FacilitatorChatContext
  ) as FacilitatorChatContextProps;

  const [messages, setMessages] = React.useState<ChatState[]>([]);

  const getChatHistoryAsync = () => {
    let newChat: ChatState[] = [];
    GetGameChatHistory(gameCode!).then((response) => {
      response?.data.forEach((chat) => {
        newChat.push({
          author: {
            id:
              chat.playerCode === '00000000-0000-0000-0000-000000000000'
                ? auth?.user?.profile.sub!
                : chat.playerCode,
            name: chat.playerName,
            avatarUrl: chat.playerAvatar
          },
          timestamp: new Date(chat.sentDateUtc),
          group: 'global-chat',
          text: chat.message
        });
      });
      setMessages(newChat);
    });
  };

  React.useEffect(() => {
    if (!chatHub || !gameCode) return;

    chatHub.on('GlobalChatReceived', (data) => {
      const { senderCode, senderName, senderAvatar, message, sentDateUtc } =
        data;
      const chat = {
        author: {
          id:
            senderCode === '00000000-0000-0000-0000-000000000000'
              ? auth?.user?.profile.sub!
              : senderCode,
          name: senderName,
          avatarUrl: senderAvatar
        },
        timestamp: new Date(sentDateUtc),
        group: 'global-chat',
        text: message
      };
      setMessages((prev) => [...prev, chat]);
    });
  }, [chatHub, gameCode]);

  React.useEffect(() => {
    getChatHistoryAsync();
  }, [props.item]);

  return (
    <FacilitatorChat
      item={props.item}
      messages={messages}
      onSendMessage={onSendMessage}
    />
  );
};
